// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_cAz","cls2":"CoScientistPricingPage-cls2_7Oq CoScientistPricingPage-cls1_cAz"};